import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { useSessionStore } from "../../store/session-store";

function promptCardService() {
  const axiosPrivate = useAxiosPrivate();
  const { sessionDetails } = useSessionStore();
  const path = `/api/v1/unstract/${sessionDetails?.orgId?.replaceAll('"', "")}`;
  const csrfToken = sessionDetails?.csrfToken;

  const requestHeaders = {
    "Content-Type": "application/json",
    "X-CSRFToken": csrfToken,
  };

  return {
    getTableSettings: (promptId) => {
      const requestOptions = {
        method: "GET",
        url: `${path}/prompt-studio/prompt/table/?prompt_id=${promptId}`,
      };

      return axiosPrivate(requestOptions);
    },
    getAllTableSettings: () => {
      const requestOptions = {
        method: "GET",
        url: `${path}/prompt-studio/prompt/table/`,
      };
      return axiosPrivate(requestOptions);
    },
    postTableSettings: (body) => {
      const requestOptions = {
        method: "POST",
        url: `${path}/prompt-studio/prompt/table/`,
        headers: requestHeaders,
        data: body,
      };

      return axiosPrivate(requestOptions);
    },
    patchTableSettings: (body, id) => {
      const requestOptions = {
        method: "PATCH",
        url: `${path}/prompt-studio/prompt/table/${id}/`,
        headers: requestHeaders,
        data: body,
      };

      return axiosPrivate(requestOptions);
    },
  };
}

export { promptCardService };
